import {RootStore} from './RootStore';
import { observable, action, reaction,runInAction } from 'mobx';
import agent from '../api/agent';
import { IUser } from '../models/General';

export default class AuthenticationStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
      this.rootStore = rootStore;
    }

    @observable user: IUser | null = null;
    @action profile = async (token:string) => {
        try 
        {   
            const user = await agent.Common.profile(token);
            runInAction(() => {
                this.user = user.result;
            });
            return user;
        } catch (error) {
            throw error;
        }
    };

    @action menu = async (emplid:string) => {
        try 
        {   
            const user = await agent.Common.menu(emplid);
            return user.result;
        } catch (error) {
            throw error;
        }
    };

    @action menuParent = async (emplid:string) => {
        try 
        {   
            const user = await agent.Common.menuParent(emplid);
            return user.result;
        } catch (error) {
            throw error;
        }
    };

    @action menuTree = async (emplid:string) => {
        try 
        {   
            const user = await agent.Common.menuTree(emplid);
            return user.result;
        } catch (error) {
            throw error;
        }
    }
}